import { ReactElement, memo } from "react";
import { theme } from "../../theme";
import { h } from "../../h";

export const UnlockIcon = memo(
    (): ReactElement => {
        return h(
            `svg`,
            {
                width: "23",
                height: "30",
                viewBox: "0 0 23 30",
            },
            h(`path`, {
                d: `M20.125 10H18.6875V7.14286C18.6875 3.2 15.4675 0 11.5 0C7.5325 0 4.3125 3.2 4.3125 7.14286H7.1875C7.1875 4.77143 9.11375 2.85714 11.5 2.85714C13.8862 2.85714 15.8125 4.77143 15.8125 7.14286V10H2.875C1.29375 10 0 11.2857 0 12.8571V27.1429C0 28.7143 1.29375 30 2.875 30H20.125C21.7063 30 23 28.7143 23 27.1429V12.8571C23 11.2857 21.7063 10 20.125 10ZM20.125 27.1429H2.875V12.8571H20.125V27.1429ZM11.5 22.8571C13.0813 22.8571 14.375 21.5714 14.375 20C14.375 18.4286 13.0813 17.1429 11.5 17.1429C9.91875 17.1429 8.625 18.4286 8.625 20C8.625 21.5714 9.91875 22.8571 11.5 22.8571Z`,
                fill: theme.colorMain,
            }),
        );
    },
);
